import { render, staticRenderFns } from "./forward-curves-input.vue?vue&type=template&id=245871d4&"
import script from "./forward-curves-input.vue?vue&type=script&lang=js&"
export * from "./forward-curves-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports